var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cracl('ROLE_ADMIN', 'config/gerarDocs'))?_c('div',{staticClass:"flex items-center cursor-pointer",on:{"click":_vm.gerarDocumentoWindow}},[_c('PosMenuIcon',{attrs:{"name":"folder-open","icon-type":"fa","icon-style":"light"}}),_c('span',{staticClass:"m-r m-l-n font-10"},[_vm._v("Gerador Doc")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }